import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import{ LoopBackAuth, causasService, calificacionService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
import {ModalMensajeConfirmacionComponent} from '../modal-mensaje-confirmacion/modal-mensaje-confirmacion.component'
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-copiar-nota',
  templateUrl: './modal-copiar-nota.component.html',
  providers:[LoopBackAuth, causasService, calificacionService, MessageService]
})
export class ModalCopiarNotaComponent implements OnInit {
  @Input() tarea
  @Input() pensum
  activarCancelar: any  = true
  activarAceptar: any = true
  count = 0
  nota = 0
  constructor(
    public activeModal: NgbActiveModal,
    public causasService:causasService,
    public modalService: NgbModal,
    public calificacionService:calificacionService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
  }
  validarNota(){
    if(!(this.nota >= this.tarea.rango_inicial  && this.nota <= this.tarea.rango_final)){
      this.activarAceptar = false
      this.toastr.warning('La calificacion esta fuera de rango', 'Alerta')

    }else{
      this.activarAceptar = true
    }
  }
  guardar(){
    this.validarNota()
    const ventana = this.modalService.open(ModalMensajeConfirmacionComponent,{
      size:'sm',
    })
    ventana.componentInstance.titulo = "Confirmación"
    ventana.componentInstance.mensaje = "Seguro en cambiar las calificaciones de los alumnos"
    ventana.result.then((result)=>{
      let porcentaje = 100 / this.tarea.notas.length;
      this.activarCancelar = false
      for(let calificacion of this.tarea.notas ){
        this.calificacionService.asignarCalificacionEstudianteMateria(this.pensum, calificacion.alumno,calificacion.aca_actividad_id,calificacion.id, this.nota, calificacion.observacion).subscribe(
          item =>{
            this.count = Math.round(this.count + porcentaje)
          }
        )
      }
      setTimeout(()=>{
        this.activarCancelar = true
        this.activeModal.close()
      },150 * this.tarea.notas.length)
    },(reason)=>{

    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-copiar-nota/modal-copiar-nota.component.ts